import React, { useState } from 'react';
import { Collapse } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../../context/ThemeContext';
import { TileKey } from './types';
import { STAT_TILES, TILE_DETAILS } from './constants';
import {
  Container,
  PageTitle,
  TilesContainer,
  StatButton,
  StatLabel,
  StatValue,
  DetailsContainer,
  StyledCollapse,
  DetailHeader,
  DetailTitle,
  CloseButton,
  DetailText,
} from './styles';

const { Panel } = Collapse;

const StaffAnalytics: React.FC = () => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };
  const [selectedTile, setSelectedTile] = useState<TileKey>('attendance');

  const toggleTile = (tile: TileKey) => {
    setSelectedTile(selectedTile === tile ? null : tile);
  };

  const activeKeys = selectedTile ? [selectedTile] : [];

  const handleCollapseChange = (keys: string | string[]) => {
    const keysArray = Array.isArray(keys) ? keys : [keys];
    setSelectedTile(keysArray.length > 0 ? (keysArray[0] as TileKey) : null);
  };

  return (
    <Container>
      <PageTitle level={2} theme={theme}>
        Staff Analytics
      </PageTitle>

      <TilesContainer>
        {STAT_TILES.map((tile) => (
          <StatButton
            key={tile.key}
            isSelected={selectedTile === tile.key}
            theme={theme}
            onClick={() => toggleTile(tile.key)}
          >
            <StatLabel theme={theme}>{tile.label}</StatLabel>
            <StatValue theme={theme}>{tile.value}</StatValue>
          </StatButton>
        ))}
      </TilesContainer>

      <DetailsContainer>
        <StyledCollapse
          activeKey={activeKeys}
          onChange={handleCollapseChange}
          theme={theme}
        >
          {STAT_TILES?.map((tile) => {
            if (!tile.key) return null;
            const detail = TILE_DETAILS[tile?.key];
            return (
              <Panel
                key={tile?.key}
                header={
                  <DetailHeader>
                    <DetailTitle level={4} theme={theme}>
                      {detail?.title}
                    </DetailTitle>
                    <CloseButton type="text" icon={<FontAwesomeIcon icon={faTimes} />}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedTile(null);
                      }}
                      theme={theme}
                    />
                  </DetailHeader>
                }>
                <DetailText theme={theme}>{detail?.content}</DetailText>
              </Panel>
            );
          })}
        </StyledCollapse>
      </DetailsContainer>
    </Container>
  );
};

export default StaffAnalytics;
